
export class FormatHelper {

    /**
     * Generiert einen Link als String für das href in einem HTML-Element um direkt anrufen zu können
     * @param phonenumber Telefonnummer
     * @returns tel:+49xxxxxxxx || tel:xxxxxxxx
     */
    public static generatePhoneHref(phonenumber: any): string {
        if (!phonenumber) return '';
        const pnStr = phonenumber.toString();
        const hrefStr = 'tel:';
        const firstChar = pnStr.substring(0, 1);
        if (firstChar === '0') {
            return hrefStr + '+49' + pnStr.substring(1);
        } else {
            return hrefStr + pnStr;
        }
    }
}